import { format, subMonths, subYears } from "date-fns";
import { arDZ, fr, enUS } from "date-fns/locale";
import { get } from "lodash";
import { computed, reactive } from "vue-demi";
import { useI18n } from "./i18n";

export function useDateLocale() {
  const { locale } = useI18n();

  const dateLocaleMap = {
    fr: fr,
    ar: arDZ,
    en: enUS
  };

  const dateLocale = computed(() =>
    get(dateLocaleMap, locale.value, dateLocaleMap.en)
  );

  return dateLocale;
}

export function usePeriodNames() {
  const dateLocale = useDateLocale();

  const names = reactive({
    prevYear: format(subYears(new Date(), 1), "MMMM", {
      locale: dateLocale.value
    }),
    prevMonth: format(subMonths(new Date(), 1), "MMMM", {
      locale: dateLocale.value
    }),
    month: format(new Date(), "MMMM", { locale: dateLocale.value }),
    year: format(new Date(), "yyyy", { locale: dateLocale.value })
  });

  return names;
}
